import { render, staticRenderFns } from "./CodeGenerator.vue?vue&type=template&id=04ca445b&scoped=true&"
import script from "./CodeGenerator.vue?vue&type=script&lang=js&"
export * from "./CodeGenerator.vue?vue&type=script&lang=js&"
import style0 from "./CodeGenerator.vue?vue&type=style&index=0&id=04ca445b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ca445b",
  null
  
)

export default component.exports